declare var require: any;

import { Directive, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Directive({
    standalone: false
})
export class BaseDirective implements OnDestroy {
    /**
     * Utilisé pour gérer la désincription des observables lorsque le composant est détruit.
     */
    protected componentDestroyed$: Subject<void> = new Subject<void>();

    /**
     * Constructeur.
     */
    constructor() {}

    /**
     * Appelée lorsque le composant est détruit.
     */
    ngOnDestroy(): void {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
}
